import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { PipeModule } from 'clink-ui-x/pipe';
import { PageHeaderComponent } from './page-header.component';
import { NzButtonModule } from 'ng-zorro-antd/button';

@NgModule({
    declarations: [PageHeaderComponent],
    imports: [CommonModule, NzButtonModule, NzToolTipModule, PipeModule],
    exports: [PageHeaderComponent],
})
export class PageHeaderModule {}
